export default "__VITE_ASSET__DxFICd3z__"